import { RESET } from '../actionTypes';
import { editTemplateViewActions } from '../reducer';

export default () => editTemplateViewActions[RESET]();
